import { Box, Loader, Modal, Tabs, Text, Button, Flex } from "@mantine/core";

import { useDisclosure } from "@mantine/hooks";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ClientSupportPlan from "../../../components/MAR/ClientSupportPlans";
import { getSinglePatients } from "../../../services/patient";
import { decrypt } from "../../../utils";
import useStyles from "./style";
import EditGaurdianinfo from "../../../components/Edit_client_profile/EditGaurdianinfo";
import EditPersonalInfo from "../../../components/Edit_client_profile/EditPersonalInfo";
import Editinsurance from "../../../components/Edit_client_profile/Editinsurance";
import PersonalHealthEdit from "../../../components/Edit_client_profile/PersonalHealthEdit";
import ClientNoteview from "../Note/ClientNoteview";
import ClientTaskView from "../Task/ClientTaskView";
import Document from "../../../components/Document";
import Medication from "../Medication";
import AddNewMedicationModal from "../../../components/AddNewMedicationModal";
import ClientInsuranceModal from "../../../components/ClientInsuranceModal";
import CareSupportModal from "../../../components/CareSupportModal";

import "./index.css";
import { QRCodeSVG } from "qrcode.react";
import { getAllPlans, getSinglePlan } from "../../../services/supportplan";
import { PDFDownloadLink } from "@react-pdf/renderer";
import ClientSummaryPDF from "../../../components/ClientSummaryPDF/ClientSummaryPDF";
import EMSFormModal from "../../../components/EMSFormModal";
import IncidentReportModal from "../../../components/IncidentReportModal";
import { getActivites } from "../../../services/activity";
import ActivitySide from "./ActivitySide";
import { TrackPageView } from "../../../config/mixpanelConfig";
import { getAllFacilitiesModal } from "../../../services";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { clearNotes } from "../../../store/reducers/note";
import UploadStaffDoc from "../../../components/StaffDetails/UploadStaffDoc";
import { isStaff } from "../../../http";
import { getAllStaffWithSignature } from "../../../services/staff";

const getInitials = (name = "") =>
  name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

const printQRModal = () => {
  const region = document.getElementById("fs-qr-print-region");
  if (!region) return;
  const html = region.innerHTML;
  const win = window.open("", "_blank", "width=520,height=760");
  if (!win) return;
  win.document.write(`<!DOCTYPE html><html><head><meta charset="UTF-8">
    <title>Client QR</title>
    <style>
      * { box-sizing: border-box; margin: 0; padding: 0; }
      body {
        font-family: 'Inter', -apple-system, 'Segoe UI', Roboto, sans-serif;
        -webkit-font-smoothing: antialiased;
        background: #fff;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding: 32px 16px;
        font-size: 14px;
        line-height: 1.5;
        color: #171717;
      }

      /* wrapper */
      .fs-qrmodal {
        width: 100%;
        max-width: 420px;
        background: #fff;
        border: 1px solid #E5E5E5;
        border-radius: 16px;
        box-shadow: none;
        position: relative;
        overflow: hidden;
      }

      /* hide close btn and actions */
      .fs-qrmodal-close,
      .fs-qrmodal-actions { display: none !important; }

      /* body grid */
      .fs-qrmodal-body {
        padding: 24px;
        display: grid;
        gap: 16px;
      }

      /* head row: photo + name */
      .fs-qrmodal-head {
        display: flex;
        align-items: center;
        gap: 14px;
      }
      .fs-qrmodal-photo {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        border: 3px solid #FFBA45;
        padding: 2px;
        background: #fff;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
      }
      .fs-qrmodal-photo img,
      .fs-qrmodal-photo-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 50%;
      }
      .fs-qrmodal-photo span {
        font-size: 18px;
        font-weight: 700;
        color: #171717;
        background: #F4F4F5;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .fs-qrmodal-identity h3 {
        margin: 0;
        font-size: 18px;
        font-weight: 700;
        color: #171717;
        letter-spacing: -0.02em;
      }
      .fs-qrmodal-identity p {
        margin: 2px 0 0;
        font-size: 12px;
        color: #667085;
      }

      /* QR box */
      .fs-qrmodal-qr {
        width: 180px;
        height: 180px;
        margin: 0 auto;
        border: 1px solid #E5E5E5;
        border-radius: 12px;
        overflow: hidden;
        padding: 6px;
        background: #fff;
      }
      .fs-qrmodal-qr svg {
        width: 100%;
        height: 100%;
        display: block;
      }

      /* sections */
      .fs-qrmodal-section {
        padding-top: 14px;
        border-top: 1px solid #F3F4F6;
      }
      .fs-qrmodal-section h4 {
        margin: 0 0 8px;
        font-size: 11px;
        font-weight: 700;
        color: #667085;
        text-transform: uppercase;
        letter-spacing: 0.08em;
      }
      .fs-qrmodal-section p {
        margin: 0;
        font-size: 13px;
        color: #262626;
        line-height: 1.55;
      }

      /* diagnosis tags */
      .fs-qrmodal-tags {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
      }
      .fs-qrmodal-tag {
        padding: 4px 10px;
        border-radius: 6px;
        background: #EFF6FF;
        color: #1D4ED8;
        font-size: 12px;
        font-weight: 500;
        border: 1px solid #BFDBFE;
      }

      @media print {
        @page { margin: 10mm; size: A5 portrait; }
        body { padding: 0; }
      }
    </style>
  </head><body><div class="fs-qrmodal"><div>${html}</div></div>
  <script>window.onload=function(){window.print();}<\/script>
  </body></html>`);
  win.document.close();
};


const Client = (props) => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [clientDetails, setClientDetails] = useState(null);
  const [showSSN, setShowSSN] = useState(false);
  const [opened, { open, close }] = useDisclosure(false);
  const [openedModal, { open: openDetails, close: closeDetails }] =
    useDisclosure(false);
  const [insuranceModal, { open: openModal, close: closeModal }] =
    useDisclosure(false);
  const [careSupportModal, { open: openCareModal, close: closeCareModal }] =
    useDisclosure(false);
  const [
    personalHealthOpened,
    { open: openPersonalHealth, close: closePersonalHealth },
  ] = useDisclosure(false);
  const [
    guardianInfoOpened,
    { open: openGuardianInfo, close: closeGuardianInfo },
  ] = useDisclosure(false);
  const [insuranceOpened, { open: openInsurance, close: closeInsurance }] =
    useDisclosure(false);
  const [loading, setLoading] = useState(true);
  const [selectedSubmission, setSelectedSubmission] = useState(null);
  const [planData, setPlanData] = useState(null);
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(location.state?.tab || "profile");
  const { selectedClient } = useSelector((state) => state.mar);
  const [shouldRefresh, setShouldRefresh] = useState(false);
  const [medicine, setMedicine] = useState(null);
  const [isPreview, setIsPreview] = useState(false);
  const [view, setView] = useState("calendar");
  const [activities, setActivities] = useState(null);
  const [activityLoading, setActivityLoading] = useState(false);
  const [emsModalOpened, setEmsModalOpened] = useState(false);
  const [qrModalOpen, setQrModalOpen] = useState(false);
  const [incidentPromptOpened, setIncidentPromptOpened] = useState(false);
  const [incidentReportOpened, setIncidentReportOpened] = useState(false);
  const [latestEMSData, setLatestEMSData] = useState(null);
  const { profile } = useSelector((state) => state?.profile);
  const id =
    typeof location.state === "string"
      ? location.state
      : location.state?.clientId ||
        location.state?.client?.client?.id ||
        location.state?.planDoc?.client?.id;
  let notificationDoc = location.state?.notificationDoc;
  let planDoc = location.state?.planDoc;

  const editFormRef = useRef();

  const form1 = clientDetails?.form1;
  const form2 = clientDetails?.form2;

  const diagnosisVal = clientDetails?.form1?.diagnosis;

  useEffect(() => {
    if (guardianInfoOpened && form2) {
      if (form2?.noCaseManager && editFormRef?.current) {
        editFormRef.current.checked = true;
      }
    }
  }, [guardianInfoOpened, form2]);

  useEffect(() => {
    _getActivites();
    getAllStaffWithSignature();
    TrackPageView("Client");
  }, [id]);

  useEffect(() => {
    if (notificationDoc) {
      setActiveTab("documents");
      setClientDetails({
        ...notificationDoc?.client,
        form1: decrypt(notificationDoc?.client?.form1),
        form2: decrypt(notificationDoc?.client?.form2),
        form3: decrypt(notificationDoc?.client?.form3),
        name: decrypt(notificationDoc?.client?.name, false),
      });
      setLoading(false);
    }
  }, [notificationDoc, location]);

  useEffect(() => {
    if (planDoc) {
      setActiveTab("support");
      setLoading(false);
    }
  }, [planDoc, location]);

  const _getActivites = async () => {
    if (id) {
      setActivityLoading(true);
      const data = await getActivites(id);
      setActivities(data);
    }
    setActivityLoading(false);
  };

  const getData = async () => {
    let patientId;
    if (state?.notificationDoc) {
      patientId = state?.notificationDoc?.client?.id;
    } else if (state?.planDoc) {
      patientId = state?.planDoc?.client?.id;
    } else if (state?.client) {
      patientId = state?.client?.client?.id;
    } else if (state?.clientId) {
      patientId = state?.clientId;
    } else if (typeof state === "string") {
      patientId = state;
    }
    if (!patientId) {
      setLoading(false);
      return;
    }
    let res = await getSinglePatients(patientId);
    setLoading(false);
    setClientDetails(res);
  };

  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(clearNotes());
    };
  }, []);

  const handleTabChange = (val) => {
    setShouldRefresh(true);
    setActiveTab(val);
    getAllFacilitiesModal("withDeleted", false);
    setTimeout(() => setActiveTab(val), 200);
    localStorage.setItem("tab", val);
  };

  const handleEMSDownloadComplete = (emsData) => {
    setLatestEMSData(emsData);
    setEmsModalOpened(false);
    setIncidentPromptOpened(true);
  };

  const openIncidentReport = () => {
    setIncidentPromptOpened(false);
    setIncidentReportOpened(true);
  };

  useEffect(() => {
    getData();
  }, [state]);




  useEffect(() => {
    const fetchPlanData = async () => {
      if (state?.planDoc) {
        const data = await getSinglePlan(state?.planDoc?.moduleId);
        setPlanData(data);
      }
    };

    fetchPlanData();
  }, [state]);

  useEffect(() => {
    if (activeTab === "medicationList") {
      getData();
    }
  }, [activeTab]);

  useEffect(() => {
    if (activeTab === "support" || activeTab === "notes") {
      if (state?.notificationDoc) {
        getAllPlans(state?.notificationDoc?.client?.id, true);
      } else if (state?.planDoc) {
        getAllPlans(state?.planDoc?.client?._id, true);
      } else {
        getAllPlans(
          typeof state === "string" ? state : state?.client?.client?.id,
          true,
        );
      }
    }
  }, [activeTab]);

  const { classes } = useStyles();

  const customId = clientDetails?.id;
  const clientId = customId?.slice(-6);

  const filteredMedications = clientDetails?.form3
    ? clientDetails?.form3?.filter(
        (medicine) =>
          medicine?.discontinued === false || !("discontinued" in medicine),
      )
    : "";

  const ssnDisplay = () => {
    if (!showSSN) return "••• - •• - ••••";
    const raw = decrypt(clientDetails?.form1?.socialSecurityNumber, false);
    if (
      (!profile?.user?.role && !profile?.user?.type) ||
      (profile?.user?.role === "admin" && profile?.user?.type === "staff")
    ) {
      return raw;
    }
    return `*****${raw?.slice(-4)}`;
  };

  return (
    <Box className={classes.content}>
      <AppNavbar title="Client" profile={profile} />

      <AddNewMedicationModal
        opened={opened}
        onclose={(nType) => {
          close();
          setMedicine(null);
          setSelectedSubmission(null);
          if (isPreview) setIsPreview(false);
        }}
        data={medicine}
        title={"Chloroquine"}
        userId={clientDetails?.id}
        isPreview={isPreview}
        getClientData={getData}
        form2={form2}
        pendingSubmission={selectedSubmission}
      />
      <EditPersonalInfo
        opened={openedModal}
        form1={form1}
        clientDetails={clientDetails}
        setClientDetails={setClientDetails}
        onclose={(nType) => {
          closeDetails();
        }}
        title={"Edit  Client Information"}
      />
      <PersonalHealthEdit
        opened={personalHealthOpened}
        form1={form1}
        onclose={closePersonalHealth}
        setClientDetails={setClientDetails}
        title={"Edit Health Information"}
      />

      <EditGaurdianinfo
        opened={guardianInfoOpened}
        form2={clientDetails?.form2}
        setClientDetails={setClientDetails}
        onclose={closeGuardianInfo}
        title={"Edit Guardian Information"}
      />

      <Editinsurance
        opened={insuranceOpened}
        setClientDetails={setClientDetails}
        form2={form2}
        onclose={closeInsurance}
        title={"Edit Insurance Information"}
      />

      <ClientInsuranceModal
        opened={insuranceModal}
        onClose={closeModal}
        data={clientDetails}
      />

      <CareSupportModal
        opened={careSupportModal}
        onClose={closeCareModal}
        clientDetails={clientDetails}
      />

      {/* QR expand modal */}
      {qrModalOpen && (
        <div
          className="fs-qrmodal-backdrop"
          onClick={() => setQrModalOpen(false)}
        >
          <div
            id="fs-qr-print-region"
            className="fs-qrmodal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="fs-qrmodal-title"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="fs-qrmodal-close"
              type="button"
              aria-label="Close"
              onClick={() => setQrModalOpen(false)}
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>

            <div className="fs-qrmodal-body">
              <div className="fs-qrmodal-head">
                <div className="fs-qrmodal-photo">
                  {clientDetails?.imageurl ? (
                    <img
                      src={decrypt(clientDetails.imageurl)}
                      alt="client"
                      className="fs-qrmodal-photo-img"
                    />
                  ) : (
                    <span>{getInitials(clientDetails?.name)}</span>
                  )}
                </div>
                <div className="fs-qrmodal-identity">
                  <h3 id="fs-qrmodal-title">{clientDetails?.name}</h3>
                  <p>Client · {clientId}</p>
                </div>
              </div>

              <div
                className="fs-qrmodal-qr"
                role="img"
                aria-label="QR code for patient chart"
              >
                <QRCodeSVG
                  value={`${window.location.origin}/scan/${customId}?name=${encodeURIComponent(clientDetails?.name || "")}&ref=${clientId}`}
                  size={200}
                  bgColor="#ffffff"
                  fgColor="#171717"
                  level="M"
                />
              </div>

              {diagnosisVal?.length > 0 && (
                <div className="fs-qrmodal-section">
                  <h4>Diagnosis</h4>
                  <div className="fs-qrmodal-tags">
                    {diagnosisVal.map((d, i) => (
                      <span key={i} className="fs-qrmodal-tag">
                        {d?.name || d?.code || d}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {(clientDetails?.form1?.summary ||
                clientDetails?.form1?.personalPreference) && (
                <div className="fs-qrmodal-section">
                  <h4>Client Summary</h4>
                  <p>
                    {clientDetails.form1.summary ||
                      clientDetails.form1.personalPreference}
                  </p>
                </div>
              )}

              <div className="fs-qrmodal-actions">
                <button
                  className="fs-qrmodal-btn"
                  type="button"
                  onClick={() => setQrModalOpen(false)}
                >
                  Close
                </button>
                <button
                  className="fs-qrmodal-btn fs-qrmodal-btn-primary"
                  type="button"
                  onClick={printQRModal}
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="6 9 6 2 18 2 18 9" />
                    <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
                    <rect x="6" y="14" width="12" height="8" />
                  </svg>
                  Print
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {loading ? (
        <Loader
          color="yellow"
          style={{
            marginTop: "190px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            left: "40%",
          }}
        />
      ) : (
        <>
          <Flex
            align="center"
            gap={5}
            m={10}
            onClick={() => {
              navigate(-1);
            }}
            style={{ cursor: "pointer", width: "fit-content" }}
          >
            <MdKeyboardArrowLeft size={30} />
            <Text fw={400} fz={14} c={"#262626"} ff={"Inter"}>
              All Clients
            </Text>
          </Flex>
          <Box className={classes.top_header} />
          {activeTab !== "profile" && (
            <Flex
              mx={20}
              gap={8}
              align="Center"
              className={`top-client-grid ${classes.profile_container}`}
            >
              <Box>
                <img
                  src={
                    clientDetails?.imageurl
                      ? decrypt(clientDetails?.imageurl)
                      : "/assets/images/personal2.png"
                  }
                  alt="client_image"
                  className="top-image"
                />
              </Box>
              <Box>
                <p className="client-name-label">Client Name</p>
                <h2 className="top-client-name">{clientDetails?.name}</h2>
                <p className="top-client-id">
                  {clientDetails?.id?.slice(0, 6)}
                </p>
              </Box>
            </Flex>
          )}

          <Box className={classes.tabsWrapper}>
            <Tabs
              defaultValue={activeTab}
              value={activeTab}
              className={classes.tabs}
            >
              <Tabs.List>
                <Tabs.Tab
                  value="profile"
                  onClick={() => {
                    _getActivites();
                    handleTabChange("profile");
                  }}
                >
                  Facesheet
                </Tabs.Tab>
                <Tabs.Tab
                  value="support"
                  id="care"
                  onClick={() => handleTabChange("support")}
                >
                  Care Plan
                </Tabs.Tab>

                {((!profile?.user?.type && !profile?.user?.role) ||
                  !profile?.user?.permissions ||
                  profile?.user?.permissions?.medication === undefined ||
                  profile?.user?.permissions?.medication === true) && (
                  <Tabs.Tab value="mar" onClick={() => handleTabChange("mar")}>
                    MAR
                  </Tabs.Tab>
                )}
                {((!profile?.user?.type && !profile?.user?.role) ||
                  !profile?.user?.permissions ||
                  profile?.user?.permissions?.note === undefined ||
                  profile?.user?.permissions?.note === true) && (
                  <Tabs.Tab
                    value="notes"
                    onClick={() => handleTabChange("notes")}
                  >
                    Notes
                  </Tabs.Tab>
                )}
                {((!profile?.user?.type && !profile?.user?.role) ||
                  !profile?.user?.permissions ||
                  profile?.user?.permissions?.task === undefined ||
                  profile?.user?.permissions?.task === true) && (
                  <Tabs.Tab
                    value="tasks"
                    onClick={() => handleTabChange("tasks")}
                  >
                    Task
                  </Tabs.Tab>
                )}
                <Tabs.Tab
                  value="documents"
                  onClick={() => handleTabChange("documents")}
                >
                  Documents
                </Tabs.Tab>
              </Tabs.List>

              {/* ===== FACESHEET TAB ===== */}
              <Tabs.Panel
                value="profile"
                className="profile-tab"
                style={{ backgroundColor: "#F5F5F5", padding: "16px 0 32px" }}
              >
                {/* Action buttons */}
                <div className="fs-topbar-actions">
                  <PDFDownloadLink
                    document={
                      <ClientSummaryPDF
                        clientData={clientDetails}
                        activities={activities}
                        facilityName={profile?.facility?.name}
                        facilityPhoto={
                          profile?.facility?.imageurl
                            ? decrypt(profile.facility.imageurl)
                            : null
                        }
                      />
                    }
                    fileName={`${
                      clientDetails?.form1?.name ?? "Client Summary"
                    }.pdf`}
                  >
                    <button className="fs-btn" type="button">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                        <polyline points="7 10 12 15 17 10" />
                        <line x1="12" y1="15" x2="12" y2="3" />
                      </svg>
                      Client Summary
                    </button>
                  </PDFDownloadLink>
                  <button
                    className="fs-btn"
                    type="button"
                    onClick={() => setEmsModalOpened(true)}
                  >
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                      <polyline points="14 2 14 8 20 8" />
                      <path d="M12 18v-6" />
                      <path d="M9 15h6" />
                    </svg>
                    EMS Sheet
                  </button>
                </div>

                {/* Hero */}
                <section
                  className="fs-card fs-hero"
                  aria-labelledby="fs-patient-name"
                >
                  <div className="fs-hero-left">
                    <div className="fs-photo-wrap">
                      {clientDetails?.imageurl ? (
                        <img
                          src={decrypt(clientDetails.imageurl)}
                          alt="client"
                          className="fs-photo-img"
                        />
                      ) : (
                        <div className="fs-photo">
                          {getInitials(clientDetails?.name)}
                        </div>
                      )}
                      <span
                        className="fs-photo-status"
                        aria-hidden="true"
                        style={{
                          backgroundColor: clientDetails?.active
                            ? "#12b886"
                            : "#adb5bd",
                        }}
                      />
                    </div>

                    <div className="fs-hero-identity">
                      <div className="fs-id-row">
                        <span>Client</span>
                        <code>{clientId}</code>
                        <span>·</span>
                        <span>
                          Admitted{" "}
                          {moment(clientDetails?.form1?.admissionDate).isValid()
                            ? moment(
                                clientDetails?.form1?.admissionDate,
                              ).format("MMM D, YYYY")
                            : "—"}
                        </span>
                      </div>

                      <div className="fs-name-row">
                        <h1 id="fs-patient-name">{clientDetails?.name}</h1>
                        {!isStaff(profile?.user?.role) ? (
                          <button
                            className="fs-btn fs-btn-primary fs-btn-sm"
                            type="button"
                            onClick={() =>
                              navigate("/home/patient", {
                                state: {
                                  clientDetails,
                                  formName: "personalInfo",
                                  edit: true,
                                },
                              })
                            }
                          >
                            <svg
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M12 20h9" />
                              <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
                            </svg>
                            Edit
                          </button>
                        ) : null}
                      </div>

                      <div className="fs-chip-row">
                        {clientDetails?.form1?.levelofneed && (
                          <span className="fs-chip">
                            Level of Need {clientDetails.form1.levelofneed}
                          </span>
                        )}
                        {clientDetails?.form1?.levelofcare && (
                          <span className="fs-chip fs-chip-accent">
                            Level of Care {clientDetails.form1.levelofcare}
                          </span>
                        )}
                        {clientDetails?.form1?.gender && (
                          <span className="fs-chip">
                            {clientDetails.form1.gender}
                            {clientDetails?.form1?.dob &&
                              ` · ${moment().diff(
                                moment(clientDetails.form1.dob),
                                "years",
                              )} yrs`}
                          </span>
                        )}
                      </div>

                      <dl className="fs-addresses">
                        {clientDetails?.form1?.currentAddress && (
                          <div className="fs-address fs-address-current">
                            <dt>
                              <span className="fs-dot" aria-hidden="true" />
                              Current address
                            </dt>
                            <dd>{clientDetails.form1.currentAddress}</dd>
                          </div>
                        )}
                        {clientDetails?.form1?.previousAddress && (
                          <div className="fs-address fs-address-previous">
                            <dt>
                              <span className="fs-dot" aria-hidden="true" />
                              Previous address
                            </dt>
                            <dd>{clientDetails.form1.previousAddress}</dd>
                          </div>
                        )}
                      </dl>
                    </div>
                  </div>

                  {/* QR card — click to expand */}
                  <aside
                    className="fs-qr-card"
                    role="button"
                    tabIndex={0}
                    aria-label="Expand chart QR code"
                    onClick={() => setQrModalOpen(true)}
                    onKeyDown={(e) => e.key === "Enter" && setQrModalOpen(true)}
                  >
                    <div className="fs-qr-head">Chart QR</div>
                    <div className="fs-qr-frame">
                      <QRCodeSVG
                        value={`${window.location.origin}/scan/${customId}?name=${encodeURIComponent(clientDetails?.name || "")}&ref=${clientId}`}
                        size={84}
                        bgColor="#ffffff"
                        fgColor="#171717"
                        level="M"
                      />
                    </div>
                    <div className="fs-qr-caption">ID: {clientId}</div>
                  </aside>
                </section>

                {/* Stats row */}
                <dl className="fs-stats-row">
                  <div className="fs-stat">
                    <dt>Date of Birth</dt>
                    <dd>
                      {clientDetails?.form1?.dob
                        ? moment(clientDetails.form1.dob).format("MMM D, YYYY")
                        : "—"}
                    </dd>
                  </div>
                  <div className="fs-stat">
                    <dt>Gender</dt>
                    <dd>{clientDetails?.form1?.gender || "—"}</dd>
                  </div>
                  <div className="fs-stat">
                    <dt>Height</dt>
                    <dd>{clientDetails?.form1?.height || "—"}</dd>
                  </div>
                  <div className="fs-stat">
                    <dt>Weight</dt>
                    <dd>
                      {clientDetails?.form1?.weight
                        ? `${clientDetails.form1.weight} lbs`
                        : "—"}
                    </dd>
                  </div>
                  <div className="fs-stat">
                    <dt>SSN</dt>
                    <dd>
                      <span>{ssnDisplay()}</span>
                      <button
                        className="fs-ssn-toggle"
                        type="button"
                        aria-label="Toggle SSN"
                        onClick={() => setShowSSN((p) => !p)}
                      >
                        {showSSN ? (
                          <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                            <circle cx="12" cy="12" r="3" />
                          </svg>
                        ) : (
                          <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                            <line x1="1" y1="1" x2="23" y2="23" />
                          </svg>
                        )}
                      </button>
                    </dd>
                  </div>
                  <div className="fs-stat">
                    <dt>Admission Date</dt>
                    <dd>
                      {clientDetails?.form1?.admissionDate
                        ? moment(clientDetails.form1.admissionDate).format(
                            "MMM D, YYYY",
                          )
                        : "—"}
                    </dd>
                  </div>
                </dl>

                {/* Main layout grid */}
                <div className="fs-layout">
                  {/* Care team — row 1, cols 1–2 */}
                  <section
                    className="fs-card fs-cell-care"
                    aria-labelledby="fs-team-heading"
                  >
                    <header className="fs-card-head">
                      <div className="fs-card-head-left">
                        <div className="fs-icon-badge fs-badge-info">
                          <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                            <circle cx="9" cy="7" r="4" />
                            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                          </svg>
                        </div>
                        <div>
                          <h2 id="fs-team-heading">Care team</h2>
                          <p>
                            Guardian, case manager, PCP, pharmacy and additional
                            providers
                          </p>
                        </div>
                      </div>
                      {!isStaff(profile?.user?.role) ? (
                        <button
                          className="fs-link-btn"
                          type="button"
                          onClick={() =>
                            navigate("/home/patient", {
                              state: {
                                clientDetails,
                                formName: "careSupportInfo",
                                edit: true,
                                disable: true,
                              },
                            })
                          }
                        >
                          Edit
                        </button>
                      ) : null}
                    </header>
                    <div className="fs-card-body">
                      <div className="fs-team-grid">
                        {form2?.emergencyContactName && (
                          <div className="fs-team-card">
                            <div className="fs-team-avatar">
                              {getInitials(form2.emergencyContactName)}
                            </div>
                            <div className="fs-team-body">
                              <div className="fs-team-role">Guardian</div>
                              <div className="fs-team-name">
                                {form2.emergencyContactName}
                              </div>
                              <div className="fs-team-contact">
                                {form2.emergencyContactPhoneNumber && (
                                  <span>
                                    {form2.emergencyContactPhoneNumber}
                                  </span>
                                )}
                                {form2.emergencyContactEmail && (
                                  <span>{form2.emergencyContactEmail}</span>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {form2?.caseManagerName && (
                          <div className="fs-team-card">
                            <div className="fs-team-avatar">
                              {getInitials(form2.caseManagerName)}
                            </div>
                            <div className="fs-team-body">
                              <div className="fs-team-role">Case Manager</div>
                              <div className="fs-team-name">
                                {form2.caseManagerName}
                              </div>
                              <div className="fs-team-contact">
                                {form2.caseManagerPhoneNumber && (
                                  <span>{form2.caseManagerPhoneNumber}</span>
                                )}
                                {form2.caseManagerEmail && (
                                  <span>{form2.caseManagerEmail}</span>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {form2?.pcpName && (
                          <div className="fs-team-card">
                            <div className="fs-team-avatar">
                              {getInitials(form2.pcpName)}
                            </div>
                            <div className="fs-team-body">
                              <div className="fs-team-role">
                                Primary Care Physician
                              </div>
                              <div className="fs-team-name">
                                {form2.pcpName}
                              </div>
                              <div className="fs-team-contact">
                                {form2.pcpPhoneNumber && (
                                  <span>{form2.pcpPhoneNumber}</span>
                                )}
                                {form2.pcpEmail && (
                                  <span>{form2.pcpEmail}</span>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {form2?.pharmacyName && (
                          <div className="fs-team-card">
                            <div className="fs-team-avatar">
                              {getInitials(form2.pharmacyName)}
                            </div>
                            <div className="fs-team-body">
                              <div className="fs-team-role">Pharmacy</div>
                              <div className="fs-team-name">
                                {form2.pharmacyName}
                              </div>
                              <div className="fs-team-contact">
                                {form2.pharmacyPhoneNumber && (
                                  <span>{form2.pharmacyPhoneNumber}</span>
                                )}
                                {form2.pharmacyEmail && (
                                  <span>{form2.pharmacyEmail}</span>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {form2?.additionalProvider?.map((p, i) => {
                          const name =
                            p.providerName ||
                            `${p.providerFirstName || ""} ${p.providerLastName || ""}`.trim();
                          return (
                            <div key={i} className="fs-team-card">
                              <div className="fs-team-avatar">
                                {getInitials(name)}
                              </div>
                              <div className="fs-team-body">
                                <div className="fs-team-role">
                                  {p.providerType}
                                </div>
                                <div className="fs-team-name">{name}</div>
                                <div className="fs-team-contact">
                                  {p.providerPhone && (
                                    <span>{p.providerPhone}</span>
                                  )}
                                  {p.providerEmail && (
                                    <span>{p.providerEmail}</span>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                        {!form2?.emergencyContactName &&
                          !form2?.caseManagerName &&
                          !form2?.pcpName &&
                          !form2?.pharmacyName &&
                          (!form2?.additionalProvider ||
                            form2.additionalProvider.length === 0) && (
                            <p
                              style={{
                                color: "#9CA3AF",
                                fontSize: "13px",
                                gridColumn: "1/-1",
                              }}
                            >
                              No care team members added
                            </p>
                          )}
                      </div>
                    </div>
                  </section>

                  {/* Active medications — row 2, col 1 */}
                  <section
                    className="fs-card fs-scroll-card fs-cell-meds"
                    aria-labelledby="fs-meds-heading"
                  >
                    <header className="fs-card-head">
                      <div className="fs-card-head-left">
                        <div className="fs-icon-badge fs-badge-accent">
                          <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M10.5 20.5 3.5 13.5a4.95 4.95 0 0 1 7-7l7 7a4.95 4.95 0 0 1-7 7z" />
                            <path d="m8.5 8.5 7 7" />
                          </svg>
                        </div>
                        <div>
                          <h2 id="fs-meds-heading">Active medications</h2>
                          <p>
                            {filteredMedications?.length || 0} prescriptions on
                            file
                          </p>
                        </div>
                      </div>
                      {!isStaff(profile?.user?.role) ? (
                        <button
                          className="fs-link-btn"
                          type="button"
                          onClick={() => open()}
                        >
                          Edit
                        </button>
                      ) : null}
                    </header>
                    <div className="fs-card-body">
                      {filteredMedications && filteredMedications.length > 0 ? (
                        filteredMedications.map((med, i) => (
                          <div
                            key={i}
                            className="fs-med"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setMedicine(med);
                              setIsPreview(true);
                              open();
                            }}
                          >
                            <div className="fs-med-icon">
                              <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <path d="M10.5 20.5 3.5 13.5a4.95 4.95 0 0 1 7-7l7 7a4.95 4.95 0 0 1-7 7z" />
                                <path d="m8.5 8.5 7 7" />
                              </svg>
                            </div>
                            <div>
                              <div className="fs-med-name">
                                {med.medicationName} {med.dosage} {med.unit}
                              </div>
                              <div className="fs-med-schedule">
                                {med.frequency} {med.ingestionMode}
                              </div>
                            </div>
                            <div className="fs-med-form">{med.dosageForm}</div>
                          </div>
                        ))
                      ) : (
                        <p
                          style={{
                            color: "#9CA3AF",
                            fontSize: "13px",
                            padding: "4px 0",
                          }}
                        >
                          No active medications
                        </p>
                      )}

                    </div>
                  </section>

                  {/* Health — row 2, col 2 */}
                  <section
                    className="fs-card fs-scroll-card fs-cell-health"
                    aria-labelledby="fs-health-heading"
                  >
                    <header className="fs-card-head">
                      <div className="fs-card-head-left">
                        <div className="fs-icon-badge fs-badge-accent">
                          <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                          </svg>
                        </div>
                        <div>
                          <h2 id="fs-health-heading">Health</h2>
                          <p>Diagnoses, allergies, dietary and services</p>
                        </div>
                      </div>
                      {!isStaff(profile?.user?.role) ? (
                        <button
                          className="fs-link-btn"
                          type="button"
                          onClick={() =>
                            navigate("/home/patient", {
                              state: {
                                clientDetails,
                                formName: "healthInfo",
                                edit: true,
                                disable: true,
                              },
                            })
                          }
                        >
                          Edit
                        </button>
                      ) : null}
                    </header>
                    <div className="fs-card-body">
                      <div className="fs-subsection">
                        <div className="fs-subsection-head">
                          <strong>Diagnosis</strong>
                        </div>
                        <div className="fs-tags">
                          {Array.isArray(clientDetails?.form1?.diagnosis) &&
                          clientDetails.form1.diagnosis.length > 0 ? (
                            clientDetails.form1.diagnosis.map((d, i) => (
                              <span key={i} className="fs-tag fs-tag-info">
                                {d.name}
                              </span>
                            ))
                          ) : diagnosisVal?.length > 0 ? (
                            diagnosisVal.map((d, i) => (
                              <span key={i} className="fs-tag fs-tag-info">
                                {d.name}
                              </span>
                            ))
                          ) : (
                            <span
                              style={{ fontSize: "12px", color: "#9CA3AF" }}
                            >
                              No diagnosis
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="fs-subsection">
                        <div className="fs-subsection-head">
                          <strong>Allergies</strong>
                        </div>
                        <div className="fs-tags">
                          {clientDetails?.form1?.knownAllergies?.filter((a) =>
                            a.trim(),
                          ).length > 0 ? (
                            clientDetails.form1.knownAllergies
                              .filter((a) => a.trim())
                              .map((a, i) => (
                                <span key={i} className="fs-tag fs-tag-danger">
                                  {a}
                                </span>
                              ))
                          ) : (
                            <span
                              style={{ fontSize: "12px", color: "#9CA3AF" }}
                            >
                              No allergies
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="fs-subsection">
                        <div className="fs-subsection-head">
                          <strong>Dietary restrictions</strong>
                        </div>
                        <div className="fs-tags">
                          {clientDetails?.form1?.dietaries?.filter((d) => d)
                            .length > 0 ? (
                            clientDetails.form1.dietaries
                              .filter((d) => d)
                              .map((d, i) => (
                                <span key={i} className="fs-tag fs-tag-success">
                                  {d}
                                </span>
                              ))
                          ) : (
                            <span
                              style={{ fontSize: "12px", color: "#9CA3AF" }}
                            >
                              No restrictions
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="fs-subsection">
                        <div className="fs-subsection-head">
                          <strong>Provider services</strong>
                        </div>
                        <div className="fs-tags">
                          {clientDetails?.form1?.services?.filter((s) => s)
                            .length > 0 ? (
                            clientDetails.form1.services
                              .filter((s) => s)
                              .map((s, i) => (
                                <span key={i} className="fs-tag">
                                  {s.servicetitle}
                                </span>
                              ))
                          ) : (
                            <span
                              style={{ fontSize: "12px", color: "#9CA3AF" }}
                            >
                              No services
                            </span>
                          )}
                        </div>
                      </div>

                      {(clientDetails?.form1?.summary ||
                        clientDetails?.form1?.personalPreference) && (
                        <div className="fs-subsection">
                          <div className="fs-subsection-head">
                            <strong>Client Summary</strong>
                          </div>
                          <div className="fs-client-summary">
                            {clientDetails?.form1?.summary ||
                              clientDetails?.form1?.personalPreference}
                          </div>
                        </div>
                      )}
                    </div>
                  </section>

                  {/* Recent activity — col 3, spans all rows */}
                  <section
                    className="fs-card fs-cell-activity"
                    aria-labelledby="fs-activity-heading"
                  >
                    <header className="fs-card-head">
                      <div className="fs-card-head-left">
                        <div className="fs-icon-badge">
                          <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
                          </svg>
                        </div>
                        <div>
                          <h2 id="fs-activity-heading">Recent activity</h2>
                          <p>Notes, tasks, MAR, documents</p>
                        </div>
                      </div>
                    </header>
                    <div className="fs-card-body fs-activity-body">
                      {activityLoading ? (
                        <Box
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "200px",
                          }}
                        >
                          <Loader color="yellow" size="md" />
                        </Box>
                      ) : (
                        <ActivitySide
                          activities={activities}
                          isActivity={true}
                        />
                      )}
                    </div>
                  </section>

                  {/* Insurance — cols 1–2, row 3 */}
                  <section
                    className="fs-card fs-cell-insurance"
                    aria-labelledby="fs-insurance-heading"
                  >
                    <header className="fs-card-head">
                      <div className="fs-card-head-left">
                        <div className="fs-icon-badge fs-badge-info">
                          <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                          </svg>
                        </div>
                        <div>
                          <h2 id="fs-insurance-heading">Insurance</h2>
                          <p>
                            {clientDetails?.form2?.insurance?.length || 0}{" "}
                            policies on file
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex", gap: "6px" }}>
                        {!isStaff(profile?.user?.role) ? (
                          <button
                            className="fs-link-btn"
                            type="button"
                            onClick={() =>
                              navigate("/home/patient", {
                                state: {
                                  clientDetails,
                                  formName: "insuranceInfo",
                                  edit: true,
                                  disable: true,
                                },
                              })
                            }
                          >
                            Edit
                          </button>
                        ) : null}
                        <button
                          className="fs-link-btn"
                          type="button"
                          onClick={() => openModal()}
                        >
                          Expand
                        </button>
                      </div>
                    </header>
                    <div className="fs-card-body">
                      <div className="fs-insurance-stack">
                        {clientDetails?.form2?.insurance ? (
                          clientDetails.form2.insurance.map((ins, i) => (
                            <article key={i} className="fs-insurance-card">
                              <div className="fs-ins-header">
                                <span className="fs-ins-type">
                                  {ins.type || ins.insuranceType}
                                </span>
                                {i === 0 && (
                                  <span className="fs-ins-primary">
                                    Primary
                                  </span>
                                )}
                              </div>
                              <h3 className="fs-ins-provider">
                                {ins.providerName ||
                                  clientDetails?.form2?.insuranceCompanyName ||
                                  "—"}
                              </h3>
                              <dl className="fs-ins-member">
                                <dt>Member ID</dt>
                                <dd>{ins.identificationNumber || "—"}</dd>
                              </dl>
                              <dl className="fs-ins-fields">
                                <div className="fs-ins-field">
                                  <dt>Subscriber</dt>
                                  <dd>
                                    {ins.subscriberName ||
                                      clientDetails?.form2?.subscriberName ||
                                      "—"}
                                  </dd>
                                </div>
                                <div className="fs-ins-field">
                                  <dt>Group</dt>
                                  <dd>
                                    {ins.groupNumber ||
                                      clientDetails?.form2?.groupNumber ||
                                      "—"}
                                  </dd>
                                </div>
                                <div className="fs-ins-field">
                                  <dt>Effective</dt>
                                  <dd>
                                    {moment(
                                      ins.effectiveDate ||
                                        clientDetails?.form2?.effectiveDate,
                                    ).isValid()
                                      ? moment(
                                          ins.effectiveDate ||
                                            clientDetails?.form2?.effectiveDate,
                                        ).format("MM/DD/YYYY")
                                      : "—"}
                                  </dd>
                                </div>
                              </dl>
                            </article>
                          ))
                        ) : (
                          <article className="fs-insurance-card">
                            <div className="fs-ins-header">
                              <span className="fs-ins-type">Medical</span>
                              <span className="fs-ins-primary">Primary</span>
                            </div>
                            <h3 className="fs-ins-provider">
                              {clientDetails?.form2?.insuranceCompanyName ||
                                "—"}
                            </h3>
                            <dl className="fs-ins-member">
                              <dt>Member ID</dt>
                              <dd>
                                {clientDetails?.form2?.identificationNumber ||
                                  "—"}
                              </dd>
                            </dl>
                            <dl className="fs-ins-fields">
                              <div className="fs-ins-field">
                                <dt>Subscriber</dt>
                                <dd>
                                  {clientDetails?.form2?.subscriberName || "—"}
                                </dd>
                              </div>
                              <div className="fs-ins-field">
                                <dt>Group</dt>
                                <dd>
                                  {clientDetails?.form2?.groupNumber || "—"}
                                </dd>
                              </div>
                              <div className="fs-ins-field">
                                <dt>Effective</dt>
                                <dd>
                                  {moment(
                                    clientDetails?.form2?.effectiveDate,
                                  ).isValid()
                                    ? moment(
                                        clientDetails.form2.effectiveDate,
                                      ).format("MM/DD/YYYY")
                                    : "—"}
                                </dd>
                              </div>
                            </dl>
                          </article>
                        )}
                      </div>
                    </div>
                  </section>
                </div>
              </Tabs.Panel>

              <Tabs.Panel value="support">
                <ClientSupportPlan
                  client={id}
                  clientDetails={clientDetails}
                  planData={planData}
                />
              </Tabs.Panel>
              {((!profile?.user?.type && !profile?.user?.role) ||
                !profile?.user?.permissions ||
                profile?.user?.permissions?.note === undefined ||
                profile?.user?.permissions?.note === true) && (
                <Tabs.Panel value="notes">
                  <ClientNoteview userId={id} activeTab={activeTab} />
                </Tabs.Panel>
              )}
              {((!profile?.user?.type && !profile?.user?.role) ||
                !profile?.user?.permissions ||
                profile?.user?.permissions?.medication === undefined ||
                profile?.user?.permissions?.medication === true) && (
                <Tabs.Panel value="mar">
                  <Medication userId={id} tabName={"mar"} />
                </Tabs.Panel>
              )}
              {((!profile?.user?.type && !profile?.user?.role) ||
                !profile?.user?.permissions ||
                profile?.user?.permissions?.task === undefined ||
                profile?.user?.permissions?.task === true) && (
                <Tabs.Panel value="tasks">
                  <ClientTaskView userId={id} activeTab={activeTab} />
                </Tabs.Panel>
              )}
              <Tabs.Panel value="documents">
                <Document
                  client={
                    notificationDoc?.client?.id
                      ? notificationDoc.client.id
                      : planDoc?.client?.id
                        ? planDoc.client.id
                        : id
                  }
                />
              </Tabs.Panel>
            </Tabs>
            <EMSFormModal
              opened={emsModalOpened}
              onClose={() => setEmsModalOpened(false)}
              clientDetails={clientDetails}
              profile={profile}
              planData={planData}
              onDownloadComplete={handleEMSDownloadComplete}
            />
            <Modal
              opened={incidentPromptOpened}
              onClose={() => setIncidentPromptOpened(false)}
              centered
              title="Complete Incident Report?"
              size="md"
              overlayProps={{ blur: 3 }}
              transitionProps={{ duration: 200 }}
              radius="md"
              zIndex={1000}
            >
              <Text size="sm" color="dimmed" mb={18}>
                The EMS form has been downloaded. Do you want to complete an
                incident report now?
              </Text>
              <Flex justify="flex-end" gap={12}>
                <Button
                  variant="default"
                  onClick={() => setIncidentPromptOpened(false)}
                >
                  No
                </Button>
                <Button
                  onClick={openIncidentReport}
                  styles={{
                    root: {
                      background: "#f0b10a",
                      borderColor: "#f0b10a",
                      color: "#ffffff",
                      fontWeight: 600,
                    },
                  }}
                >
                  Yes
                </Button>
              </Flex>
            </Modal>
            <IncidentReportModal
              opened={incidentReportOpened}
              onClose={() => setIncidentReportOpened(false)}
              clientDetails={clientDetails}
              profile={profile}
              emsData={latestEMSData}
            />
          </Box>
        </>
      )}
      {activeTab === "documents" && notificationDoc ? (
        <UploadStaffDoc
          selectedFolder={notificationDoc?.metadata?.folder}
          userId={notificationDoc?.client?.id}
          userType={notificationDoc?.userType}
          isDocument={true}
          uploadedFiles={notificationDoc?.metadata?.file}
          isnotificationdoc={true}
        />
      ) : null}
    </Box>
  );
};

export default Client;
